import { render } from "./list.template.html?vue&type=template&id=9958c672&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=9958c672&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9958c672"

export default script